import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_60: DocMigration = {
  maxSchemaVersion: "0.0.60",
  description: "remove nested drawings from sheets & room layouts",
  apply(json: any) {
    json.drawings = {};

    for (const sheetId in json.sheets) {
      const sheet = json.sheets[sheetId];
      const { drawings } = sheet;
      for (let i = 0; i < drawings.length; i++) {
        const id = uid();
        json.drawings[id] = {
          ...drawings[i],
          id,
          parentId: sheetId,
          sortIndex: i,
        };
      }

      delete sheet.drawings;
      delete sheet.type;
    }

    for (const roomLayoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[roomLayoutId];
      if (!roomLayout) {
        continue;
      }
      const { drawings } = roomLayout;
      if (!drawings) {
        continue;
      }
      for (let i = 0; i < drawings.length; i++) {
        const id = uid();
        json.drawings[id] = {
          ...drawings[i],
          id,
          parentId: roomLayoutId,
          sortIndex: i,
        };
      }
      delete json.roomLayouts[roomLayoutId].drawings;
    }
    return json;
  },
};

export default migration_0_0_60;
